import { z } from 'zod';
import type { AgbCountryData } from '@/api/types/agb';
import { httpRequest } from '@/utils/axios';
import logger from '@/utils/client-logger';

const agbCountryDataSchema = z.object({
  standard_price: z.string(),
  free_shipping_threshold: z.string(),
  countries: z.array(
    z.object({
      country_id: z.string(),
      standard_delivery: z.string(),
      standard_price: z.string(),
      business_delivery: z.string(),
      business_price: z.string(),
    }),
  ),
});

function isAgbCountryData(value: unknown): value is AgbCountryData {
  return agbCountryDataSchema.safeParse(value).success;
}

/** 当前用户的德国站配送配置；身份和异常处理沿用统一请求层。 */
export async function fetchAgbCountry(signal?: AbortSignal): Promise<AgbCountryData | null> {
  const response = await httpRequest('GET:/api/agb_country', undefined, undefined, { signal });
  // 业务错误也可能使用 HTTP 200，不能把错误体当作配送配置。
  if (response?.code !== 200) return null;

  if (!isAgbCountryData(response.data)) {
    logger.error('Invalid AGB country response');
    return null;
  }
  return response.data;
}
